<div>
    <h6 #header1 class="ap-green mt-1">{{header}}</h6>
    <div>
        <dx-data-grid #openLeadsGrid style="width: 100%" [dataSource]="openLeads" [columnAutoWidth]="true"
            [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true">
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="accountNum" caption="Account Num" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="leadID" caption="LeadID" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="campaignID" caption="Campaign ID" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="campaign" caption="Campaign" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="teamLeadSource" caption="Team Lead Source"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="leadGroup" caption="Lead Group" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="leadPriority" caption="Lead Priority"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="leadQualificationLevel" caption="Lead Qualification Level"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="crM_DESCR" caption="CRM DESCR" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="product" caption="Product" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="leadReason" caption="Lead Reason" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="leadSince" caption="Lead Since" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="createdOn" caption="Created On" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="createdBy" caption="Created By" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="territory" caption="Territory from zip"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="crmTerritory" caption="Territory from CRM"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="isFAMKAM" caption="Is FAM/ KAM" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="company" caption="Company" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="streeT60" caption="Street Address" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="citY_1" caption="CITY 1" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="region" caption="REGION" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="postalcode" caption="Postal Code" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="country" caption="Country" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="globalIndustrySegment" caption="Global Industry Segment"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="maMarketSegment" caption="Ma Market Segment"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="majorSegment" caption="Major Segment"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="apIndustrySegment" caption="AP Industry Segment"
                cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="application1" caption="Application1" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="siteName" caption="Closest AP ASU" cssClass="column-group-sub-header"></dxi-column>
            <dxi-column dataField="miles" caption="Miles to Closest AP Plant" cssClass="column-group-sub-header">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="nonCompany" caption="Closest NonAP ASU Company"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="nonSiteName" caption="Closest nonAP ASU SiteName"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="nonmiles" caption="Closest NonAP miles">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
        </dx-data-grid>
    </div>
</div>